import React from "react";
import IntelligenceWorkspaceShell from "./IntelligenceWorkspaceShell";

export default function Forecast({ children }) {
  return (
    <IntelligenceWorkspaceShell
      workspaceKey="forecast"
      eyebrow="Organisation outlook"
      title="Forecast"
      description="Projected operational health based on verified execution."
    >
      {children}
    </IntelligenceWorkspaceShell>
  );
}
